// extracted by mini-css-extract-plugin
export var dropdownIcon = "_o1-6";
export var imgContainer = "_o1-3";
export var menuIcon = "_o1-5";
export var pillWrapper = "_o1-2";
export var pillsContainer = "_o1-1";
export var subscriptionCard = "_o1-0";
export var subscriptionLogo = "_o1-4";